import { computed, state } from 'ccstate'

export const sharedLocationState = {
  reloadPathname$: state(0),
  pathname$: computed((get) => {
    get(sharedLocationState.reloadPathname$)
  
    return location.pathname
  })
}